import { useState } from "react";

interface IExpandableListProps {
  items: any[];
  getKey: (item: any) => string;
  renderItem: (item: any) => React.ReactNode;
  visibleCount?: number;
}

const ExpandableList = ({ items, getKey, renderItem, visibleCount = 3 }: IExpandableListProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!items?.length) return null;

  const visibleItems = isExpanded ? items : items.slice(0, visibleCount);

  return (
    <div>
      {visibleItems.map((item) => (
        <div key={getKey(item)}>{renderItem(item)}</div>
      ))}
      {items.length > visibleCount && (
        <button
          type="button"
          className="text-indigo-600 hover:text-indigo-900 text-xs font-medium mt-1"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          {isExpanded ? "View Less" : "View More"}
        </button>
      )}
    </div>
  );
};

export default ExpandableList;
